export default "__VITE_ASSET__DiRsO8wM__"